export * from './ResellerMagazine';
